import React, { PureComponent } from 'react';
import styled from '@emotion/styled';

const PricingCard = styled.div`
  background-color: #fff;
  border-radius: 20px;
  text-align: center;
  padding: 2rem;
  margin: 0 2rem;

  .price {
    display: flex;
    justify-content: center;
    line-height: 1;
    font-weight: 300;
    .currency {
      font-size: 31px;
    }
    .value {
      font-size: 101px;
      line-height: 0.7;
    }
    .time {
      font-size: 18px;
      align-self: flex-end;
      display: inline-block;
      margin-left: -0.5rem;
    }
  }
  .title {
    color: #8dc63f;
    font-size: 24px;
    font-weight: bold;
    margin-top: 1.5rem;
  }
  .features {
    .feature {
      color: #282c30;
      font-size: 16px;
      margin-top: 0.5rem;
    }
  }

  .cta {
    border: 1px solid #282c30;
    display: inline-block;
    background: transparent;
    border-radius: 30px;
    margin-top: 2rem;
    padding: 0.5rem 2rem;
    color: #8dc63f;
    font-weight: bold;
    letter-spacing: 3px;
    text-transform: uppercase;
    &:hover,
    &:focus,
    &:active {
      outline: none;
      box-shadow: none;
      text-decoration: none;
      border-color: #8dc63f;
    }
  }
`;

export default class PlanList extends PureComponent {
  render () {
    const { planList } = this.props;
    return (
      <div className="row">
        {planList &&
          planList.plans.map((plan, i) => (
            <div className="col-sm-12 col-md-6 col-xl-3 mb-5" key={i}>
              <PricingCard>
                <div className="price">
                  <span className="currency">{plan.plan_currency}</span>
                  <span className="value">{plan.plan_price}</span>
                  <span className="time">/{plan.plan_billing_cycle}</span>
                </div>
                <div className="plan">
                  <div className="title">{plan.plan_name}</div>
                  <div className="features">
                    {plan.plan_features.map(({ feature }, i) => {
                      return (
                        <div key={i} className="feature">
                          {feature}
                        </div>
                      );
                    })}
                  </div>
                </div>
                <a
                  href={plan.link.link_url}
                  className='cta'
                >{plan.link.link_text}
                </a>
              </PricingCard>
            </div>
          ))}
      </div>
    );
  }
}